export const DuplicateEmailErrorMessage =
  'This email address already exists, please use a different email';
